export const MAIN = '/'